import axios from "axios";
import { url } from "./url.service";
const serverUrl = url + "/career";
export const getCareer = async () => {
    return axios.get(`${serverUrl}/`);
};
